export class DeliveryCompanyModel {
    id?:number = undefined
    idSource?:number = undefined
    name?:string = ""
    isActive:boolean = false

    constructor(d?:Partial<DeliveryCompanyModel>) {
        Object.assign(this, d)
    }
}
